///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespace
//
///////////////////////////////////////////////////////////////////////////////////////////////////
window.fieldValidate = window.fieldValidate || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
window.fieldValidate.consumerRFP = {
    /**
     * Makes sure all emails in the new suppliers list are for users not in ABSetup or have not setup their accounts yet.
     *
     * @param elem
     * @param initialRun
     * @returns {boolean|Promise<boolean>}
     */
    newSuppliersNotSetupYet(elem, {initialRun = false} = {}) {
        const value = elem.val();

        if (!Array.isArray(value) || value.length === 0) {
            fieldValidate.removeOrnaments(elem);
            elem.data('newSuppliersNotSetupYetChecked', null);
            return true;
        }

        // We've already checked the current value.
        if (elem.data('newSuppliersNotSetupYetChecked') === value.join()) {
            return true;
        }

        elem.data('newSuppliersNotSetupYetChecked', value.join());
        fieldValidate.removeOrnaments(elem);

        return axios.get('/api/consumer_rfp/new_suppliers/have_setup_accounts', {
            params: {
                emails: value,
            }
        }).then(response => {
            const userAlreadySetup = response.data.result.find(resultForEmail => resultForEmail.is_setup);

            if (userAlreadySetup) {
                const orgLanguage = userAlreadySetup.orgs.length > 1 ? 'one of their orgs' : 'their org';

                fieldValidate._overwriteMessageFromSameRule(
                    elem, `${userAlreadySetup.email} has an active account. Add ${orgLanguage} to the Suppliers list to include them in this RFP: ${userAlreadySetup.orgs.sort().join(', ')}.`,
                    'newSuppliersNotSetupYet'
                );

                return false;
            }

            return true;
        });
    }
}
